import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';

import { getFromKey } from '../../services/message-filters';
import '../../styles/main.scss';
import './button-user.scss';
import MenuUser from '../menu-user/menu-user';


export function ButtonFilter(props) {
  const { t } = useTranslation();
  const {
    application,
    showSearchEvents,
    hiddeSign,
    sign,
    handleSignChange,
    accounts,
    handleDefaultCalendarChange,
    defaultCalendar,
    encodeUrl
  } = props;

  return (
    <span
      id="button-user-tooltip"
      className={`button-filter icon-user-space mdc-menu-surface--anchor`}
    >
      {window.location === window.parent.location &&
        <MenuUser
          fullName={(application && application.user && application.user.credentials &&
            application.user.credentials.name) ?
            application.user.credentials.name : ""}
          onToggleDialog={() => {}}
          hiddeSign={hiddeSign}
          showSearchEvents={showSearchEvents}
          handleSignChange={handleSignChange}
          sign={sign}
          accounts={accounts}
          defaultCalendar={defaultCalendar}
          handleDefaultCalendarChange={handleDefaultCalendarChange}
          encodeUrl={encodeUrl}
        />
      }
      <UncontrolledTooltip
        target="button-user-tooltip"
        id="button-user-tooltip"
        placement="bottom"
        popperClassName="lf-tooltip"
      >
        {t('mainBar.quickUser')}
      </UncontrolledTooltip>
    </span>
  );
}

const mapStateToProps = state => ({
  activeMessageFilter: getFromKey(state.application.messageFilterKey),
  application: state.application
});

export default connect(mapStateToProps)(ButtonFilter);
